export default __webpack_public_path__ + "static/2-69eceaeead03f05d1c4b9be3efec4a3c.png";